import { render, staticRenderFns } from "./Membre_Conferences.vue?vue&type=template&id=06630bd0&scoped=true&"
import script from "./Membre_Conferences.vue?vue&type=script&lang=js&"
export * from "./Membre_Conferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06630bd0",
  null
  
)

export default component.exports